import React, { useEffect, useRef, useState } from 'react';
import ConvertBox, { ConvertBoxStatesEnum } from './convertBox/convertBox.index';
import { MostPopularCoin } from './popularCoins/popularCoins.index';
import Reports, { ReportsRef, ReportType } from '30pay/reports/reports.index';
import { __ConvertBoxRef } from './convertBox/initial/initial.interface';

export const Trade = () => {
    const convertBoxRef = useRef<__ConvertBoxRef>(null);
    const [convertBoxState, setConvertBoxState] = useState<ConvertBoxStatesEnum>(ConvertBoxStatesEnum.Initial);
    const reportsRef = useRef<ReportsRef>(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="p-4 w-full h-full flex flex-col">
            <div
                className={`flex flex-col gap-6 h-full  ${convertBoxState === ConvertBoxStatesEnum.Initial ? 'lg:grid lg:grid-cols-2' : 'flex-row'}`}
            >
                <ConvertBox
                    onFinish={() => {
                        reportsRef.current?.updateData();
                        setConvertBoxState(ConvertBoxStatesEnum.Initial);
                    }}
                    onChangeState={(e) => setConvertBoxState(e)}
                    ref={convertBoxRef}
                />
                {convertBoxState === ConvertBoxStatesEnum.Initial && (
                    <MostPopularCoin selectCoin={(coin) => convertBoxRef.current?.setCoin(coin)} />
                )}
            </div>
            <Reports type={ReportType.OrderTransaction} ref={reportsRef} />
        </div>
    );
};
